import JSEncrypt from 'jsencrypt';
// 公钥key
const publicKey = `MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJlLIik423nKkNY/TN4BCsDqfuyR1+WxyzpHZJrP4R2XChrzHluHkJXvQaEA8jgCp74Q1NY/5TIJQlyiXktEHm0CAwEAAQ==`

export const encrypt = (data) => {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey)
  return encryptor.encrypt(data)
}